'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _ConfirmDelete = require('../common/ConfirmDelete');

var _ConfirmDelete2 = _interopRequireDefault(_ConfirmDelete);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var SavedReportDropdownItem = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(SavedReportDropdownItem, _Component);

  function SavedReportDropdownItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SavedReportDropdownItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SavedReportDropdownItem.__proto__ || Object.getPrototypeOf(SavedReportDropdownItem)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmation', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SavedReportDropdownItem, [{
    key: 'onSavedReportClick',
    value: function onSavedReportClick(event) {
      var _props = this.props,
          onSavedReportClick = _props.onSavedReportClick,
          report = _props.report;


      onSavedReportClick(report);
    }
  }, {
    key: 'onDeleteReport',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var _props2, onDeleteReport, report;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, onDeleteReport = _props2.onDeleteReport, report = _props2.report;


                event.preventDefault();

                _context.next = 4;
                return onDeleteReport(report.id);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDeleteReport(_x) {
        return _ref2.apply(this, arguments);
      }

      return onDeleteReport;
    }()
  }, {
    key: 'render',
    value: function render() {
      var report = this.props.report;


      return _react2.default.createElement(
        _MenuItem2.default,
        {
          eventKey: report,
          key: report.label,
          value: report
        },
        _react2.default.createElement(_ConfirmDelete2.default, {
          message: 'Delete ?',
          onClickDelete: this.onDeleteReport,
          onClickCancel: this.showConfirmation.setFalse,
          showConfirmDelete: this.showConfirmation.isTrue,
          small: true
        }),
        _react2.default.createElement(
          _Button2.default,
          { bsStyle: 'link', className: 'btn-report-item no-padding', onClick: this.onSavedReportClick },
          report.label
        ),
        _react2.default.createElement(
          _Button2.default,
          { bsStyle: 'link', className: 'btn-delete-report no-padding', onClick: this.showConfirmation.setTrue },
          _react2.default.createElement(_common.Icon, { type: 'trash' })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SavedReportDropdownItem;
}(_react.Component), _class3.propTypes = {
  onDeleteReport: _propTypes2.default.func.isRequired,
  onSavedReportClick: _propTypes2.default.func.isRequired,
  report: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
})), _class2)) || _class) || _class;

var _default = SavedReportDropdownItem;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SavedReportDropdownItem, 'SavedReportDropdownItem', '/app/src/components/page-reports/SavedReportDropdownItem.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-reports/SavedReportDropdownItem.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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